// 🔒
const logo = new URL("../assets/logo.webp", import.meta.url).href;

export default function DownloadCTASection() {
  return (
    <section className="section download-cta" id="download">
      <div className="container">
        <div className="download-cta__card">
          <div className="download-cta__bg download-cta__bg--one" />
          <div className="download-cta__bg download-cta__bg--two" />

          <div className="download-cta__content">
            <p className="eyebrow">GET THE APP</p>

            <h2>Take your training everywhere.</h2>

            <p className="download-cta__text">
              Download the Elefit app for premium programs, expert coaching,
              guided workouts, and a seamless fitness experience designed for
              life on the move.
            </p>

            <div className="download-cta__actions">
              <a
                href="https://apps.apple.com/"
                target="_blank"
                rel="noreferrer"
                className="store-button"
                aria-label="Download on the App Store"
              >
                <span className="store-button__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="28" height="28" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M18.71 19.5c-.83 1.24-1.71 2.45-3.05 2.47-1.34.03-1.77-.79-3.29-.79-1.53 0-2 .77-3.27.82-1.31.05-2.3-1.32-3.14-2.53C4.25 17 2.94 12.45 4.7 9.39c.87-1.52 2.43-2.48 4.12-2.51 1.28-.02 2.5.87 3.29.87.78 0 2.26-1.07 3.8-.91.65.03 2.47.26 3.64 1.98-.09.06-2.17 1.28-2.15 3.81.03 3.02 2.65 4.03 2.68 4.04-.03.07-.42 1.44-1.38 2.83M13 3.5c.73-.83 1.94-1.46 2.94-1.5.13 1.17-.34 2.35-1.04 3.19-.69.85-1.83 1.51-2.95 1.42-.15-1.15.41-2.35 1.05-3.11z"/>
                  </svg>
                </span>
                <span className="store-button__text">
                  <span className="store-button__label">Download on</span>
                  <span className="store-button__title">App Store</span>
                </span>
              </a>

              <a
                href="https://play.google.com/store"
                target="_blank"
                rel="noreferrer"
                className="store-button"
                aria-label="Get it on Google Play"
              >
                <span className="store-button__icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" width="26" height="26" fill="white" xmlns="http://www.w3.org/2000/svg">
                    <path d="M22.018 13.298l-3.919 2.218-3.515-3.493 3.543-3.521 3.891 2.202a1.49 1.49 0 0 1 0 2.594zM1.337.924a1.486 1.486 0 0 0-.112.568v21.017c0 .217.045.419.124.6l11.155-11.087L1.337.924zm12.207 10.065l3.258-3.238L3.45.195a1.466 1.466 0 0 0-.946-.179l11.04 10.973zm0 2.067l-11 10.933c.298.036.612-.016.906-.183l13.324-7.54-3.23-3.21z"/>
                  </svg>
                </span>
                <span className="store-button__text">
                  <span className="store-button__label">Download on</span>
                  <span className="store-button__title">Google Play</span>
                </span>
              </a>
            </div>
          </div>

          <div className="download-cta__visual" aria-hidden="true">
            <div className="download-cta__glow" />
            <img
              src={logo}
              alt=""
              className="download-cta__logo"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
// 🔒